import { useCreateVerificationsMutation } from "Api/Mutations/Verifications/useCreateVerificationsMutation";
import { usePartyLicensesQuery } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { getLicenseResumeState } from "Components/Licenses/licenseUtils";
import { PaidLicenseStepContent } from "Components/Onboarding/shared/PaidLicenseStepContent";
import { StepBox } from "Components/Onboarding/shared/StepBox";
import { InitiateQRPaymentComponent } from "Components/QRPayment/InitiateQRPaymentComponent";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { FullHeightForm } from "Components/Shared/FormStyles";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { getUserInfoAsync } from "State/Auth/UserInfo/GetUserInfoState";
import { useDispatch } from "react-redux";
import { Resources, useResource } from "Translations/Resources";

export const ManualLicensePaymentStep = () => {
  const currentUser = useLoggedInUser();
  const dispatch = useDispatch();
  const { t } = useResource();
  const { mutate: verifyUser, isPending } = useCreateVerificationsMutation({
    onSuccess: () => {
      dispatch(getUserInfoAsync.request(undefined));
    },
  });
  const {
    data: { items: licenses = [] } = {},
    isLoading,
    isError,
  } = usePartyLicensesQuery(currentUser?.partyPublicID);

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  if (isError) {
    return <ErrorText>{t(Resources.Errors.RequestError)}</ErrorText>;
  }

  const resumeState = getLicenseResumeState(licenses);

  if (resumeState.kind === "none") {
    return <ErrorText>{t(Resources.Errors.RequestError)}</ErrorText>;
  }

  if (resumeState.kind === "paid") {
    return (
      <PaidLicenseStepContent
        license={resumeState.license}
        onContinue={verifyUser}
        isSubmitting={isPending}
      />
    );
  }

  const { unpaidLicenses } = resumeState;
  const licenseToPay = unpaidLicenses[0];

  if (!licenseToPay?.transactionPublicID || unpaidLicenses.length > 1) {
    return <ErrorText>{t(Resources.Errors.RequestError)}</ErrorText>;
  }

  return (
    <FullHeightForm>
      <StepBox
        submitButtonLabel={t(Resources.Common.Sent)}
        onSubmitClick={verifyUser}
        isSubmitting={isPending}
      >
        <InitiateQRPaymentComponent
          publicID={licenseToPay.transactionPublicID}
        />
      </StepBox>
    </FullHeightForm>
  );
};
